import React from "react";
import ConversionSection from "./ConversionSection";

const TextToSpeech = () => {
  return (
    <>
      <ConversionSection />
    </>
  );
};

export default TextToSpeech;
